import { render, staticRenderFns } from "./CHECKBOXES.vue?vue&type=template&id=3b778269&scoped=true&"
import script from "./CHECKBOXES.vue?vue&type=script&lang=js&"
export * from "./CHECKBOXES.vue?vue&type=script&lang=js&"
import style0 from "./CHECKBOXES.vue?vue&type=style&index=0&id=3b778269&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b778269",
  null
  
)

export default component.exports